// regionConstants.js
'use strict';

export const REGION_GLOBAL = 'global';
